import request from "@/utils/httpRequest.js"

 export function login(data) {
  return request({
    url: 'login',
    method: 'post',
    data
  })
}

export function tokenLogin(data) {
  return request({
    url: 'login/token',
    method: 'post',
    data
  })
}

export function sendCode(tel) {
  return request({
    url: 'login/send-code',
    method: 'post',
    params: {
      tel: tel
    }
  })
}

export function logout() {
  return request({
    url: 'login',
    method: 'delete'
  })
}

export function jsSDKSign(url) {
  return request({
    url: 'login/js-sdk',
    method: 'post',
    params: {
      url: encodeURIComponent(url)
    }
  })
}

export function wechatLogin(params) {
  return request({
    url: 'login/wechat',
    method: 'post',
    params
  })
}

export function wechatAuth(state) {
  return request({
    url: 'login/auth',
    method: 'get',
    params: {
      state
    }
  })
}
